// Swiperの初期化（プレーンJS版）
// @see vendorの読み込みでグローバルにSwiperが利用可能であることが前提

const initLineUpSwiper = () => {
  if (!document.querySelector('.js-line-up-swiper')) return;
  if (typeof window.Swiper !== 'function') return;

  // eslint-disable-next-line no-undef
  new Swiper('.js-line-up-swiper', {
    slidesPerView: 'auto',
    loop: true,
    speed: 500,
    spaceBetween: 50,
  });

  // クリック/ドラッグ操作を無効化したい場合は必要に応じて有効化
  // swiper.allowTouchMove = false;
};

export { initLineUpSwiper };
